(function () {
    'use strict';

    function init() {
        const container = document.querySelectorAll('.js-timeline-carousel');
        if (!container) return;

        setupSwiper('.js-timeline-carousel', {
            containerSelector: '.js-timeline-carousel-container',
            jsSelector: '.js-timeline-carousel',
            swiperOptions: {
                slidesPerView: 'auto',
                spaceBetween: 12,
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();